import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import HttpAPICall from '../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import TapIcon from '../../services/TapIcon';
import TapSelect from '../../components/ui/TapSelect';
import Loader from '../../components/ui/Loader/Loader';
import AdditionalAttributeForm from '../includes/ui/AdditionalAttributeForm';


const ProjectEditModal = forwardRef((props, ref) => {

    const projectFormDataUrl        =   IAM_API_BASE_URL_2 + '/project_structure/form_data'; 
    const projectEditUrl            =   IAM_API_BASE_URL_2 + '/project/edit';
    

    const [modalId, setModalId]             =   useState(uuid());
    const modalElem                         =   useRef(null);
    const modal                             =   useRef(null);
    const access_token                      =   useSelector(state => state.auth.access_token);

    const initialData                       =   {
        id              :   '',
        name            :   '',
        category_id     :   '',
        notes           :   ''
    }

    const [formDataLoading, setFormDataLoading] =   useState(false);
    const [categories, setCategories]           =   useState([]);
    const [formSubmitting, setFormSubmitting]   =   useState(false);
    const [editData, setEditData]               =   useState(initialData);
    const [formAdditionalData, setFormAdditionalData]               =   useState([]);


    useImperativeHandle(ref, () => ({

        initModalHandler: (projectDetails) => {
            let updateFormState = [];
            if (projectDetails.additional_attr) {
                projectDetails.additional_attr.map((i, k) => {
                    let name = "additional_attributes_" + i.key;
                    updateFormState[name] = i.value;
                });
            }
            if(projectDetails) {
                setEditData({
                    id              :   projectDetails.id,
                    name            :   projectDetails.name,
                    category_id     :   projectDetails.category ? projectDetails.category.id : '',
                    notes           :   projectDetails.notes,
                    ...updateFormState
                });
               
                formData();
                openModalHandler();
            }

        }
    }));

    const modalOpen                         =   ()  => {
        if (modal.current) { modal.current.show(); }
    }
    const modalClose                        =   ()  => {
        setEditData(initialData)
        if (modal.current) { modal.current.hide(); }
    }

    useEffect(() => {
        modalElem.current                   =   document.getElementById(modalId);
        modal.current                       =   new Modal(modalElem.current, {keyboard: false, backdrop :false});
        // Cleanup on unmount
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, []);

    const formData  =   () => {
        setFormDataLoading(true);
        HttpAPICall.withAthorization('GET', projectFormDataUrl, access_token, null, null, (response) => {
            const categories    =   response.data.categories.map(c => ({label: c.name, value: c.id}));
            setCategories(categories)
            setFormAdditionalData(response.data)
            
        })
        .then(() => setFormDataLoading(pre => !pre))
    }

    const openModalHandler        =    ()  =>  {
        modalOpen();
    }

    const handleOnChange    =   (e) => {    
        setEditData(pre => ({...pre, [e.target.name] : e.target.value}))
    }

    const submitHandler =   (e)  => {
        e.preventDefault();

        const form = { ...editData };
        let additional_attributes = {};
        formAdditionalData.additional_attributes.forEach(attr => {
            const key = attr.key;
            const fieldName = "additional_attributes_" + key;
            additional_attributes[key] = form[fieldName] || "";
            delete form[fieldName];
        });
        const payload = {
            ...form,
            additional_attributes
        };
        if(editData.id) {
            setFormSubmitting(true)
            HttpAPICall.withAthorization('PUT', projectEditUrl, access_token, null, payload, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                props.getProjectDetail();
                modalClose();
            })
            .then(() => setFormSubmitting(pre => !pre))

        }else {
            toast.error('Something went wrong. You cannot edit the project.')
        }
        
    }   
 
    return <>
        <div className="modal fade" id={modalId} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Project</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={modalClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="modal-body">
                        {
                            formDataLoading 
                            ? <Loader/> 
                            :
                            <form id="editProject" onSubmit={submitHandler}>
                                    <div className="row mb-3">
                                        <div className='col-sm-3 '>
                                            <label className="col-form-label require">Name</label>
                                        </div>
                                        <div className="col-sm-7 mb-2">
                                            <input
                                                name="name"
                                                type="text"
                                                className="form-control"
                                                autoComplete="off"
                                                value={editData.name}
                                                onChange={handleOnChange}
                                                placeholder="Enter Name"
                                                required
                                            />
                                        </div>

                                        <div className='col-sm-3 '>
                                            <label className="col-form-label">Category</label>
                                        </div>
                                        <div className="col-sm-7 ">
                                            <TapSelect
                                                options={categories}
                                                isSearchable={true}
                                                isClearable={true}
                                                // isDisabled={true}
                                                value={categories.find(c => c.value === editData.category_id)}
                                                changeEvent={(selectedOption) => {
                                                    if(selectedOption.value) {
                                                        setEditData(pre => ({...pre, category_id: selectedOption.value}))
                                                    }else {
                                                        setEditData(pre => ({...pre, category_id: ''}))
                                                    }
                                                }}
                                                placeholder="Select Category"
                                            />
                                        </div>
                                            <div className='ps1'>
                                                {formAdditionalData &&
                                                    formAdditionalData.additional_attributes &&
                                                    formAdditionalData.additional_attributes.length > 0 && (
                                                        <AdditionalAttributeForm
                                                            additionalAttributes={formAdditionalData.additional_attributes}
                                                            formState={editData}
                                                            onAttributeChange={(value, attributeName) => {
                                                                setEditData({
                                                                    ...editData,
                                                                    [attributeName]: value,
                                                                })
                                                            }}
                                                            colSpan={"col-sm-7"}
                                                        />
                                                    )}
                                            </div>
                                        <div className='col-sm-3 '>
                                            <label className="col-form-label">Notes</label>
                                        </div>
                                        <div className="col-sm-7">
                                            <textarea
                                                name="notes"
                                                type="text"
                                                className="form-control"
                                                autoComplete="off"
                                                value={editData.notes}
                                                onChange={handleOnChange}
                                                placeholder="Enter Notes..."
                                            />
                                        </div>
                                </div>
                            </form>
                        }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={formSubmitting || formDataLoading} onClick={modalClose}>Close</button>
                            <button type="submit" form='editProject' className="btn btn-primary" disabled={formSubmitting || formDataLoading} >Edit {formSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
});

export default ProjectEditModal;

